import { useEffect, useState } from 'react'

type Rules = {
  one: boolean
  two: boolean
  three: boolean
  four: boolean
}

const rule1 = new RegExp(/.{8,}/) // min. 8 characters
const rule2 = new RegExp(/\d/) // must contain a number
const rule3 = new RegExp(/[A-Za-z]/) // must contain a letter
const rule4 = new RegExp(/[!@#$%^{}()[\]./\\,>~+<'"`|\-=_;:&*?]/) // must contain a special character

const usePasswordRequirements = () => {
  const [passwordState, checkRequirements] = useState('')
  const [requirements, setRequirements] = useState<Rules>({
    one: false,
    two: false,
    three: false,
    four: false
  })
  useEffect(() => {
    setRequirements({
      one: rule1.test(passwordState),
      two: rule2.test(passwordState),
      three: rule3.test(passwordState),
      four: rule4.test(passwordState)
    })
  }, [passwordState])
  return { requirements, checkRequirements }
}

export default usePasswordRequirements
